import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { omit } from 'lodash';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { writeErr } from '../common/logger';
import { getParams } from '../common/utils';
import { popupActions } from '../../store/popupStore';
import { layoutActions } from '../../store/layoutStore';
import { apiGet, getHostApi, hasPermission } from '../../store/apiWrapper';
import { repiActions, reportTypes } from '../../store/repiStore';
import { capitalize, isNullOrUndefined } from '../../store/storeFunctions';
import { addConsentToStorage, getReportsAvailability, hasConsentInStorage, isPoolReport } from '../repi/repiUtils';
import RatingCard from './rating/ratingCard';
import UnderlinedTitle from '../common/underlinedTitle';

import './repiTeaser.scss';

const POPUP_TYPES = {
    consent: "consent",
    repiGroups: "repiGroups"
};

class RepiTeaser extends React.Component {
    get repiSettings() { return JSON.parse(localStorage.getItem("auth")).repi }

    render() {
        const { data } = this.props;
        if (isNullOrUndefined(data))
            return null;

        if (hasPermission(null, "MainRepi")) {
            const reports = getReportsAvailability();
            if (this.canAccessAnyReport(reports)) 
                return this.renderReportSelection(data.entity, reports);
        }

        return this.renderTeaser(data.counts);
    }

    renderTeaser = (data) => {
        if (isNullOrUndefined(data))
            return null;

        return (
            <>
                <div style={{ marginBottom: "0.5em", paddingTop: "1.5em", fontSize: "1.1em" }}>
                    <UnderlinedTitle header={this.props.translate("Report.RepiTeaser.Header")} />
                </div>
                <div style={{ marginLeft: "7%", marginRight: "7%", textAlign: "center" }}>
                    <Translate id="Report.RepiTeaser.Body" />
                </div>
                <div className="columns is-tablet is-multiline is-centered cards-fixed-height" style={{ marginBottom: "0" }}>
                    <div className="column is-3-widescreen is-12-mobile is-6 repi-teaser-card">
                        <RatingCard
                            cardType="RepiTeaserSubjectCount"
                            title={this.props.translate("Report.RepiTeaser.SubjectCount")}
                        >
                            <div className="colorized" style={{ fontSize: "1.7em", fontWeight: "600" }}>
                                {data.subjectCount}<> </>
                                <span>{this.props.translate("Report.Common.CurrencyThousands")}<sup>+</sup></span>
                            </div>
                        </RatingCard>
                    </div>
                    <div className="column is-3-widescreen is-12-mobile is-6 repi-teaser-card">
                        <RatingCard
                            cardType="RepiTeaserContractCount"
                            title={this.props.translate("Report.RepiTeaser.ContractCount")}
                        >
                            <div className="colorized" style={{ fontSize: "1.7em", fontWeight: "600" }}>
                                {data.contractCount}<> </>
                                <span>{this.props.translate("Report.Common.CurrencyThousands")}<sup>+</sup></span>
                            </div>
                        </RatingCard>
                    </div>
                    <div className="column is-3-widescreen is-12-mobile is-6 repi-teaser-card">
                        <RatingCard
                            cardType="RepiTeaserInvoiceCount"
                            title={this.props.translate("Report.RepiTeaser.InvoiceCount")}
                        >
                            <div className="colorized" style={{ fontSize: "1.7em", fontWeight: "600" }}>
                                {data.invoiceCount}<> </>
                                <span>{this.props.translate("Report.Common.CurrencyMillions")}<sup>+</sup></span>
                            </div>
                            <div style={{ fontSize: "0.8em" }}>
                                {this.props.translate("Report.RepiTeaser.LastYears")}
                            </div>
                        </RatingCard>
                    </div>
                    <div className="column is-3-widescreen is-12-mobile is-6 repi-teaser-card">
                        <RatingCard
                            cardType="RepiTeaserOverdueAmount"
                            title={this.props.translate("Report.RepiTeaser.OverdueAmount")}
                        >
                            <div className="colorized" style={{ fontSize: "1.7em", fontWeight: "600" }}>
                                {data.overdueAmount}<> </>
                                <span>{this.props.translate("Report.Common.CurrencyBillions")}<sup>+</sup></span><> </>
                                <span>{this.props.translate(`Common.Currency.${data.currency}`)}</span>
                            </div>
                            <div style={{ fontSize: "0.8em" }}>
                                {this.props.translate("Report.RepiTeaser.LastYearsB2B")}
                            </div>
                        </RatingCard>
                    </div>
                </div>
                <div style={{ textAlign: "center", marginBottom: "1em" }}>
                    <a style={{ paddingLeft: "2em", paddingRight: "2em", fontSize: "0.9em" }}
                        className={classnames('bb-button small gradient-1', {'is-square': localStorage.locales_button_style === 'square' })}
                        href="https://www.mcribis.cz/sluzby/repi/"
                        target="_blank"
                    >
                        <Translate id='Common.MoreInformation' />
                    </a>
                </div>
            </>
        )
    }

    renderReportSelection = (data, reports) => {
        if (isNullOrUndefined(data) || isNullOrUndefined(reports))
            return null;

        const settings = this.repiSettings;

        return (
            <>
                <div className="repi-links-description"><Translate id="Report.RepiTeaser.LinksDescription" />:</div>
                <div className="repi-links-container">
                    {reports[reportTypes.creditPlus] &&
                        this.renderReportLink(reportTypes.creditPlus, data, true, this.hasConsent(data.subjectId) ? null : POPUP_TYPES.consent)}
                    {reports[reportTypes.creditMinus] && this.renderReportLink(reportTypes.creditMinus, data, true)}
                    {reports[reportTypes.subjectPlus] && this.renderReportLink(reportTypes.subjectPlus, data, true)}
                    {reports[reportTypes.poolPlus] && this.renderReportLink(reportTypes.poolPlus, data, true,
                        !settings.takeFirstGroup && Object.keys(settings.customerGroups).length > 1
                            ? POPUP_TYPES.repiGroups : this.hasConsent(data.subjectId) ? undefined : POPUP_TYPES.consent)}
                    {reports[reportTypes.poolMinus] && this.renderReportLink(reportTypes.poolMinus, data, true,
                        !settings.takeFirstGroup && Object.keys(settings.customerGroups).length > 1 ? POPUP_TYPES.repiGroups : undefined)}
                    {reports[reportTypes.invoicesPlus] && this.renderReportLink(reportTypes.invoicesPlus, data, false,
                        this.hasConsent(data.subjectId) ? null : POPUP_TYPES.consent)}
                    {reports[reportTypes.invoicesMinus] && this.renderReportLink(reportTypes.invoicesMinus, data)}
                </div>
            </>
        );
    }

    renderReportLink = (reportType, item, checkPrice = false, popupAction = null) => {
        const isDataCorerction = reportType === reportTypes.dataCorrection || reportType === reportTypes.dataCorrectionInternal;
        const isPo = item.entityType === 3;
        const params = {
            sharedRegistry: this.repiSettings.allowSharing && item.sharedRegistry,
            source: "cribis"
        };

        if ((reportType === reportTypes.poolMinus || reportType === reportTypes.poolPlus) && popupAction !== POPUP_TYPES.repiGroups) {
            const groups = Object.keys(this.repiSettings.customerGroups);
            if (groups.length > 0)
                params.poolGroup = groups[0];
        }

        const btnClass = classnames("bb-button gradient-1", {
            "is-square": localStorage.locales_button_style === "square",
            "hide-on-mobile": isDataCorerction
        });

        if (checkPrice || popupAction === POPUP_TYPES.consent) {
            return (
                <span key={reportType}
                    className={btnClass}
                    style={{ cursor: "pointer" }}
                    onClick={() => checkPrice
                        ? this.onCheckPrice(reportType, item, params, popupAction, isPo)
                        : this.displayConsentPopup(reportType, item, params, popupAction, isPo)
                    }
                >{ReactHtmlParser(this.props.translate(`Repi.Report.${capitalize(reportType)}`))}</span>
            );
        }

        return (
            <Link key={reportType}
                className={btnClass}
                to={`/repi/report/${capitalize(reportType)}/${item.subjectId}?${new URLSearchParams(params)}`}
            >{ReactHtmlParser(this.props.translate(`Repi.Report.${capitalize(reportType)}`))}</Link>
        );
    }

    onCheckPrice = (reportType, item, params, popupAction, isPo) => {
        const reportName = capitalize(reportType);
        const isPool = isPoolReport(reportType);

        let defaultPoolGroup = null;
        if (isPool) {
            defaultPoolGroup = isPool && Object.keys(this.repiSettings.customerGroups).length > 0
                ? parseInt(Object.keys(this.repiSettings.customerGroups).sort()[0])
                : null;
            params.poolGroup = defaultPoolGroup;
        }

        params = omit(params, ["consent"]);

        apiGet(`${getHostApi()}/api/repi/report/${reportName}/${item.subjectId}/check`, params,
            s => {
                if (isNullOrUndefined(s) || !s.hasData)
                    writeErr(`/api/repi/report/${reportName}/${item.subjectId}/check -- No data returned from API`);
                else if (s.data === 0 && popupAction !== POPUP_TYPES.repiGroups)
                    this.displayConsentPopup(reportType, item, params, popupAction, isPo);
                else {
                    this.props.showPopup("repiReportCreditConfirmationPopup", {
                        title: this.props.translate('Common.Warning'),
                        open: true,
                        reportName: reportName,
                        reportType: reportType,
                        requestParams:  params,
                        price: s.data,
                        error: s.error,
                        subjectId: item.subjectId,
                        consent: isPo ? true : this.hasConsent(item.subjectId),
                        isPo: isPo,
                        close: isNullOrUndefined(s.error) ? undefined : () => this.props.hidePopup(),
                        no: () => this.props.hidePopup(),
                        yes: (consent, poolGroup) => {
                            if (consent)
                                addConsentToStorage(item.subjectId);
                            if (!isNullOrUndefined(poolGroup))
                                params.poolGroup = poolGroup;
                            const searchParams = new URLSearchParams(params);
                            this.props.repiRedirect(`/report/${capitalize(reportType)}/${item.subjectId}?${searchParams}`);
                        },
                        pool: {
                            allowSelection: popupAction === POPUP_TYPES.repiGroups,
                            groups: isPool ? this.repiSettings.customerGroups : null,
                            defaultGroup: defaultPoolGroup
                        },
                    });
                }
            },
            e => writeErr(e)
        );
    }

    displayConsentPopup = (reportType, item, params, popupAction, isPo) => {
        if (!isNullOrUndefined(popupAction) && !isPo) {
            this.props.showPopup("repiConsentPopup", {
                open: true,
                close: () => { this.props.hidePopup() },
                reportName: this.props.translate(`Repi.Report.${capitalize(reportType)}`),
                onConfirm: () => {
                    addConsentToStorage(item.subjectId);
                    const searchParams = new URLSearchParams(params);
                    this.props.repiRedirect(`/report/${capitalize(reportType)}/${item.subjectId}?${searchParams}`);
                },
            });
        } else
            this.props.repiRedirect(`/report/${capitalize(reportType)}/${item.subjectId}?${new URLSearchParams(params)}`);
    }

    canAccessAnyReport = (reports) => {
        if (isNullOrUndefined(reports))
            return false;

        const filteredReports = omit(reports, ["dataCorrectionContributor", "dataCorrectionInternal"]);
        return Object.values(filteredReports).reduce((a, b) => a || b, false);
    }

    hasConsent = (subjectId) => this.props.consent === true || (getParams(window.location.search).consent || "").toString() === "true"
        || hasConsentInStorage(subjectId);
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.repi.search, layout: state.layout, user: state.userContext }),
    dispatch => bindActionCreators({ ...repiActions, ...layoutActions, ...popupActions }, dispatch),
)(RepiTeaser)));